function ez_navigation(width) {

    var navigation   = $('#_js-navigation'),
        dropdown     = $('._js-navigation-dropdown'),
        trigger      = $('._js-navigation-trigger'),
        clickAllowed = false,
        hoverAllowed = false;

    dropdown.on('mouseenter mouseleave', function(e){
        if (hoverAllowed) {
            if ( e.type === 'mouseenter') {
                $(this).addClass('_expanded');
            }
            if ( e.type === 'mouseleave') {
                $(this).removeClass('_expanded');
            }
        }
    });

    trigger.on('click', function(){
        if (clickAllowed) {
            var parent = $(this).parents('._dropdown');
            if ( !parent.hasClass('_expanded') ) {
                parent.addClass('_expanded');
            } else {
                parent.removeClass('_expanded');
            }
        }
    });


    $(window).on('load resize', function(){
        var screen  = $(window).width();

        if ( screen >= width ) {
            hoverAllowed = true;
            clickAllowed = false;
        }
        if ( screen < width ) {
            hoverAllowed = false;
            clickAllowed = true;
        }
    });

}